import { useEffect, useState } from "react";

/** 화면 주소는 해시 하나다(`#/patterns`). 라우터 라이브러리를 넣지 않는다 —
 *  폐쇄망 배포라 의존성 하나가 곧 짐이고, 이 도구의 화면은 평면이라 중첩 라우트가
 *  필요 없다. 서버 설정도 안 건드린다(해시는 서버에 안 간다). */
export function currentRoute(): string {
  const h = location.hash.replace(/^#/, "").split("?")[0];
  return h.startsWith("/") ? h : "/";
}

/** 주소 뒤 `?` 의 값 하나 — `#/board?open=t-1` 의 `open`. 화면 경로(`currentRoute`)는 이것을
 *  안 품는다: 경로로 화면을 고르고, 값은 그 화면이 읽는다. 알람이 「실제로 있는 자리」(이슈
 *  상세)로 가려고 생긴 길이다(t-in-alarm-auto). */
export function routeParam(name: string): string | null {
  const h = location.hash;
  const i = h.indexOf("?");
  return i < 0 ? null : new URLSearchParams(h.slice(i + 1)).get(name);
}

export function useRoute(): string {
  const [route, setRoute] = useState(currentRoute);
  useEffect(() => {
    const on = () => setRoute(currentRoute());
    addEventListener("hashchange", on);
    return () => removeEventListener("hashchange", on);
  }, []);
  return route;
}

/** `routeParam` 을 **주소가 바뀔 때마다** 다시 읽는다. `useRoute` 는 경로만 들고 있어서,
 *  같은 화면 안에서 `?tab=` 만 바뀌면 다시 그리지 않는다(같은 문자열이라 React 가 건너뛴다). */
export function useRouteParam(name: string): string | null {
  const [v, setV] = useState(() => routeParam(name));
  useEffect(() => {
    const on = () => setV(routeParam(name));
    addEventListener("hashchange", on);
    return () => removeEventListener("hashchange", on);
  }, [name]);
  return v;
}
